import { Monitor, Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';
import { type ThemePref, useTheme } from '../../lib/theme';

const OPTIONS: { value: ThemePref; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'Ljust', icon: Sun },
  { value: 'dark', label: 'Mörkt', icon: Moon },
  { value: 'system', label: 'Auto', icon: Monitor },
];

/** Light / dark / follow the system, as a small segmented control. */
export function ThemeToggle({ className }: { className?: string }) {
  const { pref, setPref } = useTheme();
  return (
    <fieldset
      aria-label="Utseende"
      className={cn('grid min-w-0 grid-cols-3 gap-1 rounded-lg bg-muted p-1', className)}
    >
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          aria-pressed={pref === value}
          onClick={() => setPref(value)}
          className={cn(
            'flex h-8 items-center justify-center gap-1.5 rounded-md text-xs font-medium transition-colors max-sm:h-10 max-sm:text-sm',
            pref === value
              ? 'bg-card text-foreground shadow-xs'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          <Icon className="size-3.5" />
          {label}
        </button>
      ))}
    </fieldset>
  );
}
